const timeAndDate = (): string => {
  let today = new Date();
  let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  let time = new Date().toLocaleTimeString();

  let formatted = date + '_' + time;
  return formatted;
};

export default timeAndDate;
